import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../../shadcn/components/ui/accordion";

interface FaqContent {
  questionText?: string;
  answerText?: string;
  value?: string;
}

interface props {
  faqContent?: FaqContent[];
}

export default function FAQAccordian({ faqContent }: props) {
  return (
    <>
      <Accordion type="single" collapsible className="w-full">
        {faqContent?.map((item, index) => (
          <AccordionItem
            value={item?.value ? item.value : `item-${index}`}
            key={`item-${index}`}
            variant="default"
            className=" border-b border-[#A8A8A8]"
          >
            <AccordionTrigger className="py-6 lg:py-[52px]">
              <div className="flex items-center">
                <p className="font-openSans font-normal text-mobile-body-lg lg:text-[22px] leading-[22px] lg:leading-[30px] text-brand-textBlack ">
                  {item?.questionText}
                </p>
              </div>
            </AccordionTrigger>
            <AccordionContent>
              <p className="font-openSans font-normal text-mobile-body-sm lg:text-web-body-lg leading-5 lg:leading-[22px] text-brand-textGrey">
                {item?.answerText}
              </p>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </>
  );
}
